export const countryCodeNumber = process.env.REACT_APP_COUNTRYCODE
  ? JSON.parse(process.env.REACT_APP_COUNTRYCODE)
  : [
      { id: 'Malaysia', name: '(+60)' },
      { id: 'Brunei', name: '(+673)' },
      { id: 'Indonesia', name: '(+62)' },
    ];
